import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-cancel-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'close';
    this.label = $localize`Anuluj`;
    this.style = 'tertiary';
  }
}
